import { render } from "./UpcontentSelect.vue?vue&type=template&id=f3c568a2&scoped=true"
import script from "./UpcontentSelect.vue?vue&type=script&lang=js"
export * from "./UpcontentSelect.vue?vue&type=script&lang=js"

import "./UpcontentSelect.vue?vue&type=style&index=0&id=f3c568a2&scoped=true&lang=css"
import "./UpcontentSelect.vue?vue&type=style&index=1&id=f3c568a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c568a2"]])

export default __exports__